import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  /* styles for no_photo image */
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img`
  /* width: ${(props) => (props.$static ? '200px' : '100%')}; */
  /* height: ${(props) => (props.$static ? '200px' : '100%')}; */
  /* opacity: ${(props) => props.opacity}; */
  object-fit: cover;
  width: 100%;
  height: 100%;
  cursor: pointer;
  &.noimg {
    object-fit: initial;
    width: 200px;
    height: 200px;
    cursor: auto;
  }
`;

const Arrow = styled.div`
  /* display: ${(props) => (props.$hide ? 'none' : 'ihnerit')}; */
  cursor: pointer;
  position: absolute;
  /* top: 0; */
  top: 50%;
  transform: translateY(-50%);
  color: rgba(57, 62, 68, 0.7);
  padding: 0 5px;
  border-radius: 3px;
  transition: all 0.2s ease-in;
  i {
    display: block;
  }
  &:hover {
    background: rgba(255, 255, 255, 0.5);
    color: rgba(57, 62, 68, 1);
  }
`;

export const LeftArrow = styled(Arrow)`
  left: 20px;
  font-size: 64px;
`;

export const RightArrow = styled(Arrow)`
  right: 20px;
  font-size: 64px;
`;

// export const ImageWindow = styled.div`
//   z-index: 11;
//   position: fixed;
//   width: 1248px;
//   height: 800px;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   background-color: rgba(0, 0, 0, 0.95);
//   border-radius: 20px;
//   padding: 10px;
//   & > img {
//     border-radius: 20px;
//     width: 100%;
//     height: 100%;
//   }
// `;
